export const locale = {
    lang: "en-US",
    data: {
        HELP: {
            BUTTON_LABEL: "Help"
        }
    }
};
